<template>
    <div>
        <div v-if="showLoader" class="wrapper-child">
            <img src="/assets/img/loader/loaderImageHome.svg" />
            <p>لطفا منتظر بمانید...</p>
        </div>
        <div v-else>
            <!-- responsive-header -->
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->

            <div class="wrapper default">

                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar-component></navbar-component>
                </header>
                <!-- header -->
                <!-- main -->
                
                <component :is="cart == null ? 'cartEmpty': 'nonEmptyCart' "></component>
                <!-- main -->


                <footer-component></footer-component>
                <footer-fixnav-component></footer-fixnav-component>
            </div>

        </div>
    </div>

</template>

<script>

    import { initialSite } from "../../module/initialSite";
    import cartEmpty from "./emptyCart.vue";
    import nonEmptyCart from "./nonEmptyCart.vue";

    export default {
        data() {
            return {
                showLoader: false
            }
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            } 
        },
        components: {
            'cartEmpty': cartEmpty,
            'nonEmptyCart': nonEmptyCart
        },
        beforeMount: function () {
            if (this.cart == null || (this.baseInfo == null && this.baseInfo.MinimumOrders != 0 && this.cart.CartInfo.SubTotalAmount < this.baseInfo.MinimumOrders))
                this.$router.push('/cart');
            initialSite(this);
            createPageTitle('سبد خرید');
            this.scrollTop();
        },
        methods: {
            scrollTop() {
                $(function () {
                    $('html, body').scrollTop(0);
                });
            }
        }
    }
</script>

<style scoped>
</style>